export default __webpack_public_path__ + "static/media/neutral_face_no_shadow.37aeb3f3.svg";